"use strict";

var formA11y = require("./formA11y");

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
    const $form = $(form);
    $form.find(".form-control.is-invalid").removeClass("is-invalid");
    $form.find(".validate-group.is-invalid").removeClass("is-invalid");
    formA11y.clearInvalid($form);
}

module.exports = function (formElement, payload) {
    // clear form validation first
    clearFormErrors(formElement);
    $(".alert", formElement).remove();

    if (typeof payload === "object" && payload.fields) {
        Object.keys(payload.fields).forEach(function (key) {
            if (payload.fields[key]) {
                const validationGroup = $(formElement).find("[name=\"" + key + "\"]").parents(".validate-group");
                if (validationGroup.length > 0) {
                    const feedbackGroupElement = validationGroup.siblings(".invalid-feedback");

                    if (feedbackGroupElement.length > 0) {
                        feedbackGroupElement.html(payload.fields[key]);
                        validationGroup.addClass("is-invalid");
                        validationGroup.find(".form-control").addClass("is-invalid");
                        formA11y.markInvalid(validationGroup);
                    }
                } else {
                    const feedbackElement = $(formElement).find("[name=\"" + key + "\"]")
                        .parent()
                        .children(".invalid-feedback");

                    if (feedbackElement.length > 0) {
                        if (Array.isArray(payload[key])) {
                            feedbackElement.html(payload.fields[key].join("<br/>"));
                        } else {
                            feedbackElement.html(payload.fields[key]);
                        }
                        const $control = feedbackElement.siblings(".form-control");
                        $control.addClass("is-invalid");
                        formA11y.markInvalid($control);
                    }
                }
            }
        });
    }
    if (payload && payload.error) {
        const form = $(formElement).prop("tagName") === "FORM"
            ? $(formElement)
            : $(formElement).parents("form");

        form.prepend("<div class=\"alert alert-danger\" role=\"alert\">"
            + payload.error.join("<br/>") + "</div>");
    }

    // Errors are rendered and associated by this point, so move focus to the first field
    // in error and let the screen reader announce it.
    formA11y.focusFirstInvalid(formElement);
};
